import * as React from 'react'
import styled, { useTheme } from 'styled-components'
import { useMediaQuery } from '../../hooks/use-media-query'
import { FloatingBottomPanelComponent, FloatingBottomPanelRow } from './floating-bottom-panel.component'
import { useClickOutside } from '../../hooks/use-click-outside'

export const DropdownBox = styled.div`
  position: absolute;
  z-index: 100000;
  top: 100%;
  left: auto;
  right: 0;
  margin: 0;
  min-width: 16em;
  font-size: 1rem;
  overflow: visible;
  background-color: #ffffff;
  border: 1px solid ${ props => props.theme.colors.clr_divider };
  transform: translateY(10px);
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;

  a {
    color: ${ props => props.theme.colors.clr_0 } !important;
    &:hover { color: ${ props => props.theme.colors.clr_1 } !important; }
  }

  .dropdownbox-item {
    @media (min-width: ${props => props.theme.breakpoints.l}px) {
      white-space: nowrap;
    }
  }

  .dropdownbox-item + .dropdownbox-item {
    border-top: 1px solid ${ props => props.theme.colors.clr_divider };
  }
`

const SectionTitleDiv = styled.div`
  font-weight: bold;
  background-color: ${ props => props.theme.colors.clr_0_lightest };
  padding: 0.4em;
`

export interface Props {
  children: (React.ReactNode | { sectionTitle: string })[]
  label: React.ReactElement
  closeOnClick?: boolean
  closeOnOusideClick?: boolean
  dropdownBoxStyle?: React.CSSProperties
  dropdownBoxItemStyle?: React.CSSProperties
  containerStyle?: React.CSSProperties
}

export default function DropdownComponent ({
  children,
  label,
  closeOnClick = true,
  closeOnOusideClick = true,
  dropdownBoxStyle = {},
  dropdownBoxItemStyle = {},
  containerStyle = { display: 'inline-block' }
}: Props) {
  const theme = useTheme()
  const isSmall = useMediaQuery(`(max-width: ${ theme.breakpoints.m - 1}px)`)
  const [menuDeployed, setMenuDeployed] = React.useState(false)
  const ref = React.useRef<HTMLDivElement>()

  const closeDeployedMenuOnOusideClick = React.useCallback(() => {
    if (closeOnOusideClick) setMenuDeployed(false)
  }, [closeOnOusideClick])

  useClickOutside(ref, closeDeployedMenuOnOusideClick, { active: menuDeployed, stopPropagation: closeOnClick })

  return <div ref={ ref } style={ containerStyle }>
    { React.cloneElement(label, { onClick: () => setMenuDeployed(!menuDeployed) }) }

    { menuDeployed && <div style={{ position: 'relative' }}>
      { !isSmall && <DropdownBox style={ dropdownBoxStyle }>
        { children.filter(Boolean).map((child, index) => typeof child === 'object' && 'sectionTitle' in child
          ? <SectionTitleDiv key={ index } children={ child.sectionTitle } />
          : <div key={ index } className='dropdownbox-item' style={ dropdownBoxItemStyle } onClick={ () => setMenuDeployed(!closeOnClick) }>
              { React.isValidElement(child)
                ? React.cloneElement(child, { style: { padding: '0.7rem', ...(child.props as any).style } } as any)
                : child }
            </div>) }
      </DropdownBox> }

      { isSmall && <FloatingBottomPanelComponent onCancel={ () => setMenuDeployed(false) }>
        { children.filter(Boolean).map((child, index) => typeof child === 'object' && 'sectionTitle' in child
          ? <div key={ index } className="u-mtm"><b>{ child.sectionTitle }</b></div>
          : <FloatingBottomPanelRow key={ index } style={{ padding: 0 }} onClick={ () => setMenuDeployed(!closeOnClick) }>
            { React.isValidElement(child)
              ? React.cloneElement(child, { style: { padding: '1em', width: '100%', textAlign: 'left' } } as any)
              : child }
          </FloatingBottomPanelRow>) }
      </FloatingBottomPanelComponent> }
    </div> }
  </div>
}
